module.exports = __webpack_public_path__ + "static/media/siba.fe4c2147.png";